var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M5 15.304l2.697-2.66a.5.5 0 0 1 .619-.066l2.823 1.79 3.906-3.73a.5.5 0 0 1 .674-.015L19 13.486V6a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v9.304zm0 1.405V18a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.187l-3.595-3.136-3.858 3.685a.5.5 0 0 1-.614.06l-2.817-1.787L5 16.71zM4 16.5V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-1.5zM8.5 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" })
  );
});